<template>
    <div class="page-layout">
		<div class="pb-5 pt-5 d-flex align-items-center">
            <div class="d-flex align-items-center mr-2">
                <div v-if="$route.path != '/archievetickets'" @click="gotoManageTicket()">
                    <el-tooltip class="item pull-left" effect="dark" content="Click to Go Back" placement="top">
                        <img src="https://cdn.digicollect.com/cdn/scmnew/images/scm/previous.svg" class="mr-2">
                    </el-tooltip>
                </div>
                <router-link v-if="!$route.path.startsWith('/archievetickets')" :to="{ path: $routerHistory.next().path }">
                    <el-tooltip class="item pull-left" effect="dark" content="Click to Go Forward"
                        placement="top">
                        <img src="https://cdn.digicollect.com/cdn/scmnew/images/scm/next.svg">
                    </el-tooltip>
                </router-link>
            </div>
			<el-tooltip class="item" effect="dark" content="Manage Tickets" placement="top">
                <div class="manage mr-2" @click="gotoManageTicket()" v-if="list && list.length">
                    <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images-new/menu/manage_ticket.svg" alt="">
                </div>
            </el-tooltip>
            <div class="divide_line" v-if="list && list.length"></div>
            <div class="d-flex align-items-center">
                <ul class="ticket_list mb-0">
                    <li class="ticket_list_number" :class="{'ticket_list_number-selected':selected == index}" v-show="index<=6" @click="select_tab(index, item)" v-for="(item,index) in list" :key="index">
                        {{item.name}}
                        <span class="ml-2" @click="remove_tab(index,$event)">
                            <i class="icon icon-close fs-14"></i>
                        </span>
                    </li>
                    <li class="dropdown" v-if="list.length>7">
                        <button class="dropbtn">
                            <i class="icon-chevron-down" style="position:relative;top:3px"></i>
                        </button>
                        <div class="dropdown-content">
                            <a data-toggle="tab" :class="{'ticket_list_number-selected':selected == index+7}" v-for="(item,index) in list.slice(7,list.length)" :key="index" class="nav-link tabbed pointer d-flex align-items-center justify-content-between" v-on:click="select_tab(index+7, item)" @click="selected_ticket_id=item.ticket_id" style="padding: 12px 6px;width: 100%;border-radius: 5px !important;">
                                <span class="li_span text-nowrap mr-2">
                                    {{item.name}}
                                </span>
                                <!-- <span class="close_tab" v-if="index>0"> -->
                                    <el-tooltip class="item" effect="dark" content="Close" placement="top">
                                        <i class="icon-close-circle-outline pointer no-border" style="margin-right: 0px!important;" v-on:click="remove_tab(index+7,$event);"></i>
                                    </el-tooltip>
                                <!-- </span> -->
                            </a>
                        </div>
                    </li>
                </ul>
            </div>
		</div>
        <list-view v-show="(selected == 0 || selected > 0) && selected_name =='manage-ticket'"></list-view>
        <div class="" v-for="(item,index) in list" :key="index">
            <ticket-details v-show="index==selected && selected_name=='ticket-details'" :ticket_id="item.ticket_id" :is_parent_ticket="item.is_parent_ticket" :subject="item.subject" :ticket_number="item.name" :index="index"></ticket-details>
        </div>
	</div>
</template>
<script>
import Vue from "vue";
import { EventBus } from '../eventBus/nav-bar-event'
const ListView = () => import("./ListView.vue");
const TicketDetails = () => import("./TicketDetails.vue")
export default {
    data(){
        return{
            list: [],
            selected: "",
            selected_name: "manage-ticket",
            totalTickets: 0,
            selected_ticket_id: "",
            triggerZinde:false
        }
    },
    components:{
        ListView,
        TicketDetails
    },
    methods:{
        addTicket(ticket) {
            var ticket_id = ticket.ticket_id;
            var ticket_number = ticket.ticket_number;
            var is_parent_ticket = ticket.is_parent_ticket || false
            var subject = ticket.subject || ''
            var is_present = false;
            var obj = {};
            this.list.forEach(function(tab) {
                if (tab.ticket_id == ticket_id) {
                    is_present = true;
                    obj = tab;
                    return;
                }
            });
            if (is_present) {
                this.selected = this.list.indexOf(obj);
                this.selected_name = obj.value;
            } else {
                if (this.list.length >= 7) {
                    this.list.splice(this.list.length, 0, {
                        name: "Ticket #" + ticket_number,
                        value: "ticket-details",
                        ticket_id: ticket_id,
                        is_parent_ticket:is_parent_ticket,
                        subject:subject
                    });
                } else {
                    this.list.push({
                        name: "Ticket #" + ticket_number,
                        value: "ticket-details",
                        ticket_id: ticket_id,
                        is_parent_ticket:is_parent_ticket,
                        subject:subject
                    });
                }
                this.selected_name = "ticket-details";
                this.$router.push({ path: "/archievetickets/" + ticket_id });
                this.totalTickets++;
                this.selected = this.list.length - 1;
            }
        },
        select_tab(item, obj){
            var prev = this.selected;
            this.selected = item;
            this.selected_ticket_id = obj.ticket_id;
            if (item >= 7) {
                this.selected = prev;
                var x = this.list[prev];
                this.list[prev] = obj;
                this.list[item] = x;
            }
            this.selected_name = obj.value;
            if (obj.value == "ticket-details") {
                this.$router.push({ path: "/archievetickets/" + obj.ticket_id }).catch(()=>{});
                EventBus.$emit('ReloadDetailsDataById',obj.ticket_id)
            } else if (obj.value == "manage-ticket") {
                this.$router.push({ path: "/archievetickets/" }).catch(()=>{});
            }
        },
        remove_tab(index,e){
            this.totalTickets = this.totalTickets - 1;
            e.stopImmediatePropagation();
            Vue.delete(this.list, index);
            if (this.selected == index) {
                this.selected = index - 1;
            } else if (this.selected > index) {
                this.selected = this.selected - 1;
            }
            if(this.selected < 0) this.selected = 0
            if(this.list && this.list.length){
                this.selected_name = this.list[this.selected].value;
            }
            if (this.selected_name == "ticket-details") {
                if(this.list && this.list.length){
                    this.$router.push({
                        path: "/archievetickets/" + this.list[this.selected].ticket_id
                    }).catch(()=>{});
                    EventBus.$emit('ReloadDetailsDataById', this.list[this.selected].ticket_id)
                }else{
                    this.$router.push({ path: "/archievetickets" }).catch(()=>{});
                    this.selected_name = "manage-ticket"
                }
            } else if (this.selected_name == "manage-ticket") {
                this.$router.push({ path: "/archievetickets" }).catch(()=>{});
            }
        },
        gotoManageTicket(){
            // this.$router.push({ path: "/archievetickets/" }).catch(()=>{});
            // this.selected_name = "manage-ticket"

            if(String(this.$route.path).startsWith('/pm')) {
                this.$router.push({
                    path: "/pm/archievetickets/"
                }).catch(()=>{});
            }
            else {
                // this.$router.push({
                //     path: "/ticketdetails/"
                // }).catch(()=>{});
                if(this.$route.query.view_ticket) {
                    this.$router.push({ path: "/archievetickets", query: {'view_ticket': this.$route.query.view_ticket} })
                } else {
                    this.$router.push({ path: "/archievetickets" }).catch(()=>{});
                }
            }
            // if(this.selected_name == 'ticket-details'){
            //     let statusTab = []
            //     EventBus.$emit('updateTableViewTab',statusTab)
            // }
            this.selected_name = "manage-ticket"
        },
    },
    mounted(){
        EventBus.$on('tabactivateArchieve',ticket=>{
            this.addTicket(ticket)
        })
        EventBus.$on('ReopenedSuccess',index=>{
            this.list.forEach((el,lIndex)=>{
                if(lIndex == index){
                    this.list.splice(lIndex,1)
                    this.selected_name = "manage-ticket"
                    EventBus.$emit('ReopenedSuccessUpdate')
                }
            })
        })
        EventBus.$on('updateArchieveView',()=>{
            this.list = []
            this.selected_name = "manage-ticket"
        })
        if(this.$route.name == 'ArchieveListView'){
            if(this.selected_name == 'manage-ticket' && this.$route.params && this.$route.params.id != ''){
                this.$router.push({ path: "/archievetickets/" }).catch(()=>{});
            }
        }
    },
    destroyed(){
        EventBus.$off('tabactivateArchieve');
    }
}
</script>
<style scoped>
.ticket_list{
    padding-left: 0px;
    display: inline-block;
    flex-direction: row;
}
.ticket_list_number{
    list-style: none;
    background-color: #ffffff;
    padding: 5px 10px;
    border-radius: 5px;
    max-width: 150px;
    display: inline-block;
    margin-right: 5px;
    cursor: pointer;
}
.ticket_list_number i{
    border:1px solid #000000;
    border-radius:50px;
    color: #000000;
}
.ticket_list_number-selected{
    background-color: #005dae !important;
    color: #fff !important;
}
.ticket_list_number-selected .li_span{
    color: #fff !important
}
.ticket_list_number-selected i{
    color: #fff !important;
    border:1px solid #fff !important;
}
.ticket_list_number-selected i.no-border{
    border: none !important;
}
.divide_line{
    border: 1px solid #005dae;
    margin-left: 10px;
    margin-right: 10px;
    height: 30px;
}
.dropbtn {
    background-color: #005dae;
    color: #fff;
    cursor: pointer;
    margin-top: -5px;
    border-radius: 5px;
    line-height: 33px;
}
.dropbtn:hover {
    background-color: #005dae;
}
.dropbtn i {
    color: #fff !important;
}
.dropdown {
    position: relative;
    display: inline-block;
}
.dropdown-content {
    display: none;
    position: absolute;
    background-color: #fff;
    /* min-width: 180px; */
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 1;
    border-radius:5px;
    z-index: 1;
    right: 0px;
    top: 32px;
}
.dropdown-content a {
    color: black;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
}
.dropdown-content a:not([href]):not([tabindex]).tabbed {
    width: 100%;
    vertical-align: middle;
}
.dropdown-content a:not([href]):not([tabindex]).tabbed:hover {
    background-color: #eee;
}
.dropdown:hover .dropdown-content {
    display: block;
}
</style>